import { render, staticRenderFns } from "./AddNews.vue?vue&type=template&id=e5140942&scoped=true&"
import script from "./AddNews.vue?vue&type=script&lang=js&"
export * from "./AddNews.vue?vue&type=script&lang=js&"
import style0 from "./AddNews.vue?vue&type=style&index=0&id=e5140942&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5140942",
  null
  
)

export default component.exports